import { render, staticRenderFns } from "./HelpTab.vue?vue&type=template&id=399317b2&scoped=true"
import script from "./HelpTab.vue?vue&type=script&lang=ts"
export * from "./HelpTab.vue?vue&type=script&lang=ts"
import style0 from "./HelpTab.vue?vue&type=style&index=0&id=399317b2&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399317b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399317b2')) {
      api.createRecord('399317b2', component.options)
    } else {
      api.reload('399317b2', component.options)
    }
    module.hot.accept("./HelpTab.vue?vue&type=template&id=399317b2&scoped=true", function () {
      api.rerender('399317b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/HelpTab.vue"
export default component.exports